import { Box, Grid } from '@mui/material';
import {
    StyledButtonApprove,
    StyledButtonDeny,
    StyledButtonNoReviewRequired,
    StyledButtonPartialApprove
} from './StyledApprovalButtons';
import { CaseProcedureModel } from '../../../../lib/models/CaseProcedureModel';
import { DecisionReasonModel } from '../../../../lib/models/DecisionReasonModel';
import DecisionReasonSelect from '../../DecisionReasonSelect';
import { ApprovalStatuses } from './InitialReviewProcedureItem';

type ApprovalButtonsDecisionsContainerProps = {
    //ApprovalButtons
    approvalStatus: string | null;
    isNewCase: boolean;
    handleApprove: () => void;
    handlePartialApprove: () => void;
    handleDeny: () => void;
    handleNoReviewRequired: () => void;

    //DecisionReaonsSelect
    item: CaseProcedureModel;
    reasons: DecisionReasonModel[] | null;
    handleReasonDenialChange: () => void;
};

const ApprovalButtonsDecisionsContainer = ({
    approvalStatus,
    isNewCase,
    handleApprove,
    handlePartialApprove,
    handleDeny,
    handleNoReviewRequired,
    item,
    reasons,
    handleReasonDenialChange
}: ApprovalButtonsDecisionsContainerProps) => {
    return (
        <Grid container flex="flex-start" spacing={1} columnSpacing={2}>
            <Grid item>
                <StyledButtonApprove
                    onClick={handleApprove}
                    approvalstatus={approvalStatus}
                    isnew={isNewCase.toString()}>
                    Approve
                </StyledButtonApprove>
            </Grid>
            <Grid item>
                <StyledButtonPartialApprove
                    disabled={item.requestedUnits === 1}
                    onClick={handlePartialApprove}
                    approvalstatus={approvalStatus}
                    isnew={isNewCase.toString()}>
                    Partial Approve
                </StyledButtonPartialApprove>
            </Grid>
            <Grid item>
                <StyledButtonDeny
                    onClick={handleDeny}
                    approvalstatus={approvalStatus}
                    isnew={isNewCase.toString()}>
                    Deny
                </StyledButtonDeny>
            </Grid>
            <Grid item>
                <StyledButtonNoReviewRequired
                    onClick={handleNoReviewRequired}
                    approvalstatus={approvalStatus}
                    isnew={isNewCase.toString()}>
                    No Review Required
                </StyledButtonNoReviewRequired>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{ display: 'inline', borderColor: 'red' }}>
                    <DecisionReasonSelect
                        procedureId={item.crmCaseCodeId}
                        decisionReasons={item.decisionReasons}
                        reasons={reasons}
                        disabled={approvalStatus === ApprovalStatuses.Approved}
                        required={
                            approvalStatus
                                ? approvalStatus !== ApprovalStatuses.Approved &&
                                  approvalStatus !== ApprovalStatuses.NoReviewRequired &&
                                  item.decisionReasons &&
                                  item.decisionReasons.length <= 0
                                : false
                        }
                        handleReasonDenialChange={handleReasonDenialChange}
                        approvalStatus={approvalStatus}></DecisionReasonSelect>
                </Box>
            </Grid>
        </Grid>
    );
};

export default ApprovalButtonsDecisionsContainer;
